// extracted by mini-css-extract-plugin
export var coloredTitle = "style-mod--colored-title--49d49";
export var descriptionContainer = "style-mod--description-container--2d1df";
export var icon = "style-mod--icon--2d28d";
export var line = "style-mod--line--b13d4";
export var textCol = "style-mod--text-col--0c33a";
export var title = "style-mod--title--fd468";
export var titleContainer = "style-mod--title-container--f6e53";
export var titleIcon = "style-mod--title-icon--ff554";
export var uspContainer = "style-mod--usp-container--d5978";
export var uspDescription = "style-mod--usp-description--64f4f";
export var uspSectionLayout = "style-mod--usp-section-layout--b79b0";
export var uspTitle = "style-mod--usp-title--51a3e";